import {symphonyaOrderStatus, type SymphonyaOrderTone} from "@zaaaz/shared";
import {cn} from "@/lib/utils";
import {AdminBadge} from "../ui/AdminBadge";

type Props = {
  symphonya: number;
  errorHint?: string;
  className?: string;
};

function badgeVariant(tone: SymphonyaOrderTone): "secondary" | "danger" | "warning" {
  if(tone === "error") return "danger";
  if(tone === "synced") return "warning";
  return "secondary";
}

export function SymphonyaOrderBadge({symphonya, errorHint, className}: Props) {
  const status = symphonyaOrderStatus(symphonya);
  const title = status.tone === "error" && errorHint
    ? `${status.title}: ${errorHint.slice(0, 160)}`
    : status.title;

  return (
    <span title={title} className="inline-flex">
      <AdminBadge
        variant={badgeVariant(status.tone)}
        className={cn("min-w-[3.25rem] justify-center tabular-nums font-semibold", className)}
      >
        {status.label}
      </AdminBadge>
    </span>
  );
}
